import { FC } from 'react'

import { Card, Cluster, Grid, GridItem, Separator, Skeleton, Stack } from '@forto-dev/phoenix-ui-core'
import { Layout, LayoutVariant } from '@forto-dev/phoenix-ui-core/ship'

import { Footer } from '@/fragments/footer'
import { Header } from '@/fragments/header'
import { Navigation } from '@/fragments/navigation'

import { NotificationSortContextProvider } from './hooks/NotificationSortContextProvider'
import { NotificationsTitle } from './list/title'
import { NotificationSelect } from './NotificationSelect'

export const NotificationDetailsSkeleton: FC = () => {
  return (
    <Card>
      <Cluster gap={8}>
        <Cluster />
        <Stack fullWidth gap={24}>
          <Stack gap={16}>
            <Skeleton variant="badge" />
            <Separator orientation="horizontal" />
          </Stack>
          <Stack gap={24}>
            <Cluster gap={8}>
              <Skeleton variant="icon" />
              <Skeleton variant="button" />
            </Cluster>
            <Grid col={12} gap={16}>
              <Skeleton variant="button" />
              <GridItem span={3}>
                <Skeleton variant="button" fullWidth />
              </GridItem>
              <GridItem span={1}>
                <Skeleton variant="button" />
              </GridItem>
              <GridItem span={1}>
                <Skeleton variant="button" />
              </GridItem>
              <Skeleton variant="button" />
              <GridItem span={2}>
                <Skeleton variant="button" />
              </GridItem>
            </Grid>
          </Stack>
          <Separator orientation="horizontal" />
          <Stack gap={24}>
            {Array.from({ length: 3 }).map((_, index) => (
              <Grid col={12} gap={24} key={index}>
                <GridItem span={1}>
                  <Skeleton variant="badge" fullWidth />
                </GridItem>
                <GridItem span={4}>
                  <Skeleton variant="badge" fullWidth />
                </GridItem>
              </Grid>
            ))}
          </Stack>
          <Separator orientation="horizontal" />
          <Stack fullWidth gap={8}>
            <Stack />
            <Stack />
            <Stack />
            <Stack />
            <Grid col={12}>
              <GridItem span={7}>
                <Skeleton variant="button" fullWidth />
              </GridItem>
            </Grid>
            <Grid col={12}>
              <GridItem span={3}>
                <Skeleton variant="button" fullWidth />
              </GridItem>
            </Grid>
            <Stack />
            <Stack />
            <Stack />
            <Stack />
          </Stack>
          <Separator orientation="horizontal" />
          <Stack gap={8}>
            <Grid col={12}>
              <GridItem span={7}>
                <Skeleton variant="badge" fullWidth />
              </GridItem>
            </Grid>
            <Grid col={12}>
              <GridItem span={4}>
                <Skeleton variant="badge" fullWidth />
              </GridItem>
            </Grid>
            <Stack />
            <Skeleton variant="button" />
            <Stack />
            <Stack />
          </Stack>
        </Stack>
      </Cluster>
    </Card>
  )
}

export const NotificationsSidebarSkeleton: FC = () => {
  return (
    <Stack gap={8}>
      <Grid col={12}>
        <GridItem span={7}>
          <Skeleton variant="button" fullWidth />
        </GridItem>
      </Grid>
      <Skeleton variant="button" />
      <Cluster gap={8}>
        <Skeleton variant="badge" />
        <Skeleton variant="badge" />
      </Cluster>
      <Stack>
        {Array.from({ length: 3 }).map((_, index) => (
          <Card key={index}>
            <Cluster gap={8} y="center" fullWidth>
              <Skeleton variant="icon" />
              <Stack fullWidth gap={8}>
                <Grid col={8}>
                  <GridItem span={3}>
                    <Skeleton variant="badge" fullWidth />
                  </GridItem>
                  <GridItem span={3}>
                    <Skeleton variant="badge" fullWidth />
                  </GridItem>
                </Grid>
                <Skeleton variant="button" fullWidth />
                <Skeleton variant="badge" />
              </Stack>
            </Cluster>
          </Card>
        ))}
      </Stack>
    </Stack>
  )
}

export const NotificationsSkeletonLayout: FC = () => {
  return (
    <NotificationSortContextProvider>
      <Layout
        type={LayoutVariant.Notification}
        header={<Header />}
        navigation={<Navigation />}
        title={<NotificationsTitle />}
        sidebar={<NotificationsSidebarSkeleton />}
        main={<NotificationSelect />}
        footer={<Footer />}
      />
    </NotificationSortContextProvider>
  )
}
